import { useMemo } from 'react';

import type Search from 'views/logic/search/Search';
import useUserDateTime from 'hooks/useUserDateTime';
import { onInitializingTimerange } from 'views/components/TimerangeForForm';
import { WIDGET_DEFAULTS } from 'data-lake/preview/Constants';
import type { InternalDataLakeSearchType } from 'data-lake/preview/types/internal/Types';
import type { DataLakeURLQueryParams } from 'data-lake/preview/Types';

const useInitialSearchBarFormValues = (executedSearch: Search, initialUrlParams: DataLakeURLQueryParams) => {
  const { formatTime } = useUserDateTime();

  return useMemo(() => {
    if (executedSearch) {
      const searchType = executedSearch.queries.first().searchTypes[0] as InternalDataLakeSearchType;

      return {
        stream: searchType.streams[0],
        timerange: onInitializingTimerange(searchType.timerange, formatTime),
        fields: {
          fieldFilters: searchType.field_filters ?? WIDGET_DEFAULTS.fieldFilters,
          operator: searchType.filters_operator ?? WIDGET_DEFAULTS.fieldsOperator,
        },
      };
    }

    return {
      stream: initialUrlParams.stream,
      timerange: initialUrlParams.timerange ?? WIDGET_DEFAULTS.timerange,
      fields: {
        fieldFilters: initialUrlParams.fields?.fieldFilters ?? WIDGET_DEFAULTS.fieldFilters,
        operator: initialUrlParams.fields?.operator ?? WIDGET_DEFAULTS.fieldsOperator,
      },
    };
  }, [executedSearch, formatTime, initialUrlParams.fields, initialUrlParams.stream, initialUrlParams.timerange]);
};

export default useInitialSearchBarFormValues;
